import { Network, Clock, Users, ArrowDown } from "lucide-react";
import { StatPill } from "@/components/StatPill";

export const DepartmentalAutonomyHeroSection = () => {
  return (
    <section className="pt-6 sm:pt-8">
      <div className="flex flex-wrap items-center gap-2 mb-4">
        <span className="px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
          Business IT
        </span>
        <span className="text-muted-foreground text-sm flex items-center gap-1">
          <Clock className="h-3.5 w-3.5" /> 9 min read
        </span>
      </div>
      
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4 leading-tight">
        Stop Skipping Levels: Why Leaders Must Respect the Chain of Command
      </h1>
      
      <p className="text-lg sm:text-xl text-muted-foreground mb-6 max-w-3xl">
        When CEOs message developers directly, when founders give feedback to skip-levels, when executives bypass managers—the entire organization suffers. Top-down hierarchy violations destroy manager authority and create chaos.
      </p>
      
      <div className="flex flex-wrap gap-3 mb-8">
        <StatPill value="67%" label="of managers feel bypassed" />
        <StatPill value="45%" label="higher manager turnover" />
        <StatPill value="3x" label="slower team decisions" />
      </div>
      
      <div className="grid sm:grid-cols-3 gap-4 p-6 bg-card border border-border rounded-xl">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-destructive/10 rounded-lg">
            <ArrowDown className="h-5 w-5 text-destructive" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Skip-Level Problem</h3>
            <p className="text-sm text-muted-foreground">Leaders going directly to ICs</p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <div className="p-2 bg-destructive/10 rounded-lg">
            <Users className="h-5 w-5 text-destructive" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Bypassed Managers</h3>
            <p className="text-sm text-muted-foreground">Authority and context lost</p>
          </div>
        </div>
        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Network className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">The Solution</h3>
            <p className="text-sm text-muted-foreground">Communicate through the chain</p>
          </div>
        </div>
      </div>
    </section>
  );
};
